var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment, useEffect, useRef, useState } from "react";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack } from "@mui/material";
import MuiTabs from "@mui/material/Tabs";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MuiTab from "@mui/material/Tab";
const hiddenSx = {
    visibility: 'hidden',
    height: 0,
    maxHeight: 'unset',
    minHeight: 'unset',
    padding: 0
};
export function Tabs(props) {
    const { orientation = "horizontal", scrollButtons = "auto", allowScrollButtonsMobile = true, sx, onChange, items: inItems, value } = props, rest = __rest(props, ["orientation", "scrollButtons", "allowScrollButtonsMobile", "sx", "onChange", "items", "value"]);
    const items = inItems.map((item, i) => (Object.assign(Object.assign({}, item), { value: typeof item.value == "undefined" ? i : item.value })));
    const ref = useRef(null);
    const [dropdownEl, setDropdownEl] = useState(null);
    const [overflowIndex, setOverflowIndex] = useState(items.length);
    const selectedIndex = items.findIndex((item) => item.value == value);
    function handleTabOverflow(root, items) {
        // clientWidth: what the user can see
        // scrollWidth: actual size of the DOM object
        const { clientWidth } = root;
        // this basically loop through each item size and adding up the width of all items
        // if the width exceed the clientWidth of the root node, item will be hidden from the horizontal tab display
        // else the item remains visible and its ref from the dropdown list will be hidden otherwise
        let overflowIndex = 0;
        let itemsWidth = 0;
        for (let i = 0; i < items.length; i++) {
            itemsWidth += items[i].width;
            if (itemsWidth < clientWidth) {
                overflowIndex++;
            }
        }
        setOverflowIndex(overflowIndex);
    }
    useEffect(() => {
        if (ref.current) {
            // fetch the root node of tabs
            const root = Array.from(ref.current.children).find(e => e.className.includes('tabRoot'));
            if (root) {
                // from the root node, traverse down to list node of tab items
                const list = Array.from(root.children).find(e => e.className.includes('tabList'));
                const items = list ? Array.from(list.children).map((e, index) => ({ index, width: e.clientWidth })) : [];
                // apply the resize observer to the root node and watch for the size changes
                const resizeObserver = new ResizeObserver(() => handleTabOverflow(root, items));
                resizeObserver.observe(root);
                return () => resizeObserver.disconnect();
            }
        }
    }, [ref]);
    return (React.createElement(Stack, { flex: 1, direction: "row", alignItems: "center", sx: {
            borderBottom: 1,
            borderColor: "divider"
        } },
        React.createElement(MuiTabs, Object.assign({ ref: ref, orientation: "horizontal", visibleScrollbar: false, scrollButtons: false, allowScrollButtonsMobile: false, sx: Object.assign(Object.assign({}, sx), { flex: 1 }), classes: {
                scroller: 'tabRoot',
                flexContainer: 'tabList'
            }, value: value, onChange: onChange }, rest), items
            .map((tabProps, i) => (React.createElement(MuiTab, Object.assign({ key: 'muiTab-' + i, iconPosition: "start" }, tabProps, { sx: Object.assign(Object.assign(Object.assign({}, tabProps.sx), (i >= overflowIndex ? { display: "none" } : undefined)), { minHeight: 48 }) }))))),
        (overflowIndex < items.length) && (React.createElement(Fragment, null,
            React.createElement(IconButton, { sx: {
                    ml: 1
                }, onClick: ev => setDropdownEl(ev.currentTarget), color: selectedIndex >= overflowIndex ? "primary" : "default" },
                React.createElement(MoreHorizIcon, { fontSize: "inherit" })),
            React.createElement(Menu, { anchorEl: dropdownEl, open: !!dropdownEl, onClose: () => setDropdownEl(null) }, items
                .map((tabProps, i) => {
                const { label, icon, onClick, component, value: itemValue } = tabProps, rest = __rest(tabProps, ["label", "icon", "onClick", "component", "value"]);
                const selected = value == itemValue;
                function handleClick(ev) {
                    if (!selected && onChange) {
                        onChange(ev, i);
                    }
                    if (onClick) {
                        onClick(ev);
                    }
                    setDropdownEl(null);
                }
                return (React.createElement(MenuItem, Object.assign({ key: 'dropdownItem-' + i, onClick: handleClick, component: component !== null && component !== void 0 ? component : "li", sx: i < overflowIndex ? hiddenSx : {}, selected: selected }, rest),
                    icon && React.createElement(ListItemIcon, null, icon),
                    React.createElement(ListItemText, null, label)));
            }))))));
}
//# sourceMappingURL=Tabs.js.map